import { c as _c } from "react/compiler-runtime";
type SpacerProps = {
  size?: number;
  axis?: "vertical" | "horizontal";
};
const Spacer = t0 => {
  const $ = _c(3);
  const {
    size: t1,
    axis: t2
  } = t0;
  const size = t1 === undefined ? 8 : t1;
  const axis = t2 === undefined ? "vertical" : t2;
  let t3;
  if ($[0] !== axis || $[1] !== size) {
    t3 = <div className="bg-[#F7F7F8]" style={axis === "vertical" ? {
      height: size
    } : {
      width: size
    }} />;
    $[0] = axis;
    $[1] = size;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export default Spacer;